import React, { memo } from "react";
import { defineMessages, FormattedNumber } from "react-intl";
import { LocalizedText } from "../../../i18n/LocalizedText.js";
import { withEmptyCheck, EmptyLabel } from "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
import "@mui/material";
import "../../../tooltip/Tooltip.js";
import "moment-timezone";
import "../../../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../tooltip/AutoAdjustedComplexTooltip.styles.js";
import { MultiLineAutoAdjustedWidthTooltip } from "../../../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import { renderValueWithTooltip } from "./GridCellWithTooltip.js";
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["CasinoCoin"] = "CasinoCoin";
  return Currency2;
})(Currency || {});
const currencyLocalized = defineMessages({
  [
    "CasinoCoin"
    /* CasinoCoin */
  ]: {
    id: "casinoCoinCurrency",
    defaultMessage: "C Coin"
  }
});
const CurrencyCellFormatter = memo(({ currency, isNet, ...props }) => {
  const value = props?.value ?? 0;
  return currency === "CasinoCoin" ? /* @__PURE__ */ React.createElement(React.Fragment, null, value?.toString() + " ", /* @__PURE__ */ React.createElement(LocalizedText, { label: currencyLocalized.CasinoCoin })) : /* @__PURE__ */ React.createElement(React.Fragment, null, isNet && value > 0 ? "+" : null, /* @__PURE__ */ React.createElement(FormattedNumber, { value, format: currency }));
});
const CurrencyCell = withEmptyCheck((props) => {
  return /* @__PURE__ */ React.createElement(CurrencyCellFormatter, { ...props });
});
const renderCurrencyCell = (params, currency) => {
  const value = params.value;
  return /* @__PURE__ */ React.createElement(CurrencyCell, { value, currency });
};
const renderGridCurrencyWithTooltip = (params, currency) => {
  const value = params.value;
  return renderValueWithTooltip(/* @__PURE__ */ React.createElement(CurrencyCellFormatter, { value, currency }));
};
const renderAmountCurrencyCellWithTooltip = (params) => {
  const value = params.value;
  return renderValueWithTooltip(/* @__PURE__ */ React.createElement(CurrencyCell, { value: value?.amount, currency: value?.currency }));
};
function renderMuiGridCurrencyCell(params) {
  const { amount, currency } = params.value;
  return currency ? /* @__PURE__ */ React.createElement(MultiLineAutoAdjustedWidthTooltip, { linesCount: 1 }, /* @__PURE__ */ React.createElement(CurrencyCellFormatter, { value: amount, currency })) : /* @__PURE__ */ React.createElement(React.Fragment, null, amount);
}
function renderCurrencyCellWithEmptyCheck(params) {
  const { amount } = params.value;
  const isEmpty = amount === null || amount === void 0;
  const Component = renderMuiGridCurrencyCell;
  return isEmpty ? /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" }) : /* @__PURE__ */ React.createElement(Component, { ...params });
}
export {
  Currency,
  CurrencyCell,
  CurrencyCellFormatter,
  renderAmountCurrencyCellWithTooltip,
  renderCurrencyCell,
  renderCurrencyCellWithEmptyCheck,
  renderGridCurrencyWithTooltip,
  renderMuiGridCurrencyCell
};
//# sourceMappingURL=CurrencyCell.js.map
